import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { config } from '@uhg-abyss/web/tools/config';
import { event } from '@uhg-abyss/web/tools/event';
import { getUserInfoDataForEAPM } from '../../tools/utils/utils';

const useAction = (actionFn) => {
  const dispatch = useDispatch();
  return useCallback(
    (...args) => {
      return dispatch(actionFn(...args));
    },
    [dispatch]
  );
};

export const ACTION_TYPE = 'GET_API_HEALTH_CHECK';

export const useApiHealthCheck = () => {
  const result = useSelector((state) => {
    return state[ACTION_TYPE];
  });

  const action = useAction((args) => {
    const eapm = window.elasticApm;
    let transaction;
    let status;
    let statusText;
    if (eapm) {
      transaction = eapm.startTransaction(ACTION_TYPE, 'http-request', {
        managed: false,
      });
    }
    return (dispatch) => {
      dispatch({ type: `${ACTION_TYPE}_CALLED` });
      fetch(`${config('AWS_PROXY_URL')}${config('HEALTH_CHECK_API')}`, {
        withCredentials: 'include',
      })
        .then((res) => {
          status = res.status;
          statusText = res.statusText;

          event('API_TRANSACTION', {
            fields: {
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('HEALTH_CHECK_API'),
              method: 'GET',
              userInfo: args?.userInfo,
              code: res.status,
              operationName: ACTION_TYPE,
              message: res.statusText,
            },
          });
          return res.json();
        })
        .then((res) => {
          dispatch({
            type: `${ACTION_TYPE}_COMPLETED`,
            payload: res,
          });
        })
        .catch((error) => {
          dispatch({
            type: `${ACTION_TYPE}_ERROR`,
            payload: error,
          });

          statusText = 'Error';

          event('API_TRANSACTION_ERROR', {
            fields: {
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('HEALTH_CHECK_API'),
              method: 'GET',
              userInfo: args?.userInfo,
              operationName: ACTION_TYPE,
            },
          });
        })
        .finally(() => {
          if (transaction) {
            const outcome = status && status === 200 ? 'success' : 'error';

            transaction.addLabels({
              result: outcome,
              appVersion: process.env.PACKAGE_VERSION,
              url: window.location.href,
              endpoint: config('HEALTH_CHECK_API'),
              method: 'GET',
              code: status,
              message: statusText,
              operationName: ACTION_TYPE,
              ...getUserInfoDataForEAPM(args?.userInfo),
            });

            transaction.end({ outcome });
          }
        });
    };
  });

  return [result, action];
};
